const SNOOZE_AUDIT_FIELDS = new Set([
  'snoozed_until',
  'snoozed_by_user_id',
  'snooze_clears_on_edit',
  'snooze_note',
  'snooze_preset',
]);

export function isInvoiceSnoozeAuditField(fieldName: string): boolean {
  return SNOOZE_AUDIT_FIELDS.has(fieldName);
}

export function withoutInvoiceSnoozeAuditFields(
  fieldNames: string[],
): string[] {
  return fieldNames.filter((name) => !SNOOZE_AUDIT_FIELDS.has(name));
}

function diffSide(value: unknown, side: 'old' | 'new'): unknown {
  if (value && typeof value === 'object' && side in value) {
    return (value as { old?: unknown; new?: unknown })[side];
  }
  return side === 'new' ? value : undefined;
}

/**
 * How an audit row should read when it changes the snooze columns.
 * `until` and `note` are the values after the write.
 */
export function readInvoiceSnoozeAudit(
  changedFields: Record<string, unknown> | null | undefined,
): {
  kind: 'snoozed' | 'cleared';
  until: string | null;
  note: string | null;
} | null {
  if (!changedFields) return null;
  const untilField = changedFields.snoozed_until;
  if (untilField == null) return null;
  const next = diffSide(untilField, 'new');
  const previous = diffSide(untilField, 'old');
  const noteValue = diffSide(changedFields.snooze_note, 'new');
  const note =
    typeof noteValue === 'string' && noteValue.trim() ? noteValue : null;
  if (typeof next === 'string' && next) {
    return { kind: 'snoozed', until: next, note };
  }
  if (next == null && previous != null) {
    return { kind: 'cleared', until: null, note: null };
  }
  return null;
}
